<template>
  <div class="link-selector">
    <a v-if="fullPath" href="javascript:void(0)" :title="fullPath.pathText" class="link-selector__link">
      <el-tag :closable="!disabled" @close="clearLink" @click="editCouponLink">
        <div class="link-selector__tag-content">{{ fullPath.pathText }}</div>
      </el-tag>
    </a>
    <el-cascader
      v-else
      v-model="link_types"
      :options="options"
      :props="props"
      :show-all-levels="false"
      :disabled="disabled"
      placeholder="请选择跳转链接"
      size="mini"
      @change="handleCascaderChange"
    />
    <coupon-link-picker
      :visible.sync="show_coupon_picker"
      :selected-id="link && link.type === 'coupon' ? link.value : ''"
      @confirm="handleCouponPickerConfirm"
    />
    <en-shop-picker
      :show.sync="show_shop_picker"
      :buyer-domain="$$Domain['buyer_pc']"
      :request="$$Request"
      :limit="1"
      @confirm="handleShopPickerConfirm"
    />
    <en-goods-picker
      :show.sync="show_goods_picker"
      :type="$$DecorType"
      :limit="1"
      @confirm="handleGoodsPickerConfirm"
      @close="show_goods_picker = false"
    />
    <en-page-picker
      :show.sync="show_page_picker"
      :request="$$Request"
      :domain="$$Domain"
      :limit="1"
      type="decor"
      @confirm="handlePagePickerConfirm"
    />
    <el-dialog
      title="选择商品分组"
      :visible.sync="show_goods_group_picker"
      width="560px"
      append-to-body
      @open="loadGoodsGroups"
      @opened="filterGoodsGroups"
      @closed="resetGoodsGroupPicker"
    >
      <el-input
        v-model="goods_group_keyword"
        class="goods-group-picker-search"
        placeholder="请输入商品分组名称"
        prefix-icon="el-icon-search"
        clearable
        size="small"
      />
      <div v-loading="goods_group_loading" class="goods-group-picker">
        <el-tree
          ref="goodsGroupTree"
          :data="goods_group_options"
          :props="goods_group_tree_props"
          node-key="group_id"
          :filter-node-method="filterGoodsGroupNode"
          highlight-current
          default-expand-all
          empty-text="暂无匹配的商品分组"
          @node-click="handleGoodsGroupSelect"
        >
          <span slot-scope="{ data }" class="goods-group-picker__node">
            <span>{{ data.group_name }}</span>
            <span class="goods-group-picker__count">{{ data.goods_count || 0 }} 件商品</span>
          </span>
        </el-tree>
      </div>
      <span slot="footer">
        <el-button @click="show_goods_group_picker = false">取消</el-button>
        <el-button type="primary" :disabled="!pending_goods_group" @click="handleGoodsGroupConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CouponLinkPicker from '../CouponLinkPicker/main.vue'
import { couponLinkUnavailableReason, normalizeCouponLinkId } from '@/utils/coupon-claim'
import * as Rules from '@/utils/rules'
import * as API_Shop from '@/api/shop'
import * as API_Pages from '@/api/pages'
import { getVisibleGoodsGroups, getVisibleGoodsGroup } from '@/api/goods-group'
import { clientType } from '@/utils/decor-types'

export default {
  name: 'LinkSelector',
  components: { CouponLinkPicker },
  props: {
    value: {
      type: [Object, String],
      required: true
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      link: '',
      link_types: '',
      options: [
        {
          label: '微页面',
          value: '微页面',
          children: [
            { label: '微页面', value: 'mini-page' },
            { label: '店铺主页', value: 'shop-home' },
            { label: '个人中心', value: 'user-center' }
          ]
        },
        {
          label: '商品',
          value: '商品',
          children: [
            { label: '全部商品', value: 'goods' },
            { label: '部分商品', value: 'part-goods' },
            { label: '购物车', value: 'cart' },
            { label: '分类', value: 'category' },
            { label: '商品分组', value: 'goods-group' }
          ]
        },
        {
          label: '营销工具',
          value: '营销工具',
          children: [
            { label: '积分商城', value: 'points-mall', disabled: clientType === 'pc' },
            { label: '领券中心', value: 'coupons' },
            { label: '指定优惠券', value: 'coupon', disabled: clientType === 'pc' },
            { label: '限时抢购', value: 'seckill' },
            { label: '拼团活动', value: 'assemble' }
          ]
        },
        {
          label: '其他',
          value: '其他',
          children: [
            { label: '自定义链接', value: 'custom' },
            { label: '小程序路径', value: 'mini-program', disabled: clientType === 'pc' }
          ]
        },
      ],
      props: { expandTrigger: 'hover' },
      shopInfo: '',
      show_coupon_picker: false,
      show_shop_picker: false,
      show_goods_picker: false,
      show_page_picker: false,
      show_goods_group_picker: false,
      goods_group_loading: false,
      goods_group_keyword: '',
      goods_group_options: [],
      goods_group_tree_props: { label: 'group_name', children: 'children' },
      pending_goods_group: null,
      goodsGroupItem: null,
      miniPageItem: '',
      shopItem: ''
    }
  },
  watch: {
    goods_group_keyword() { this.filterGoodsGroups() },
    show_coupon_picker(visible) {
      if (!visible && !this.link) this.link_types = ''
    },
    value: {
      immediate: true,
      handler: 'defaultValueChange'
    }
  },
  model: { event: 'update', prop: 'value' },
  mounted() {
    this.shopItem = this.$$ShopInfo
  },
  computed: {
    fullPath() {
      if (!this.link || !this.link_types) return
      const option = this.options.filter(item => item.value === this.link_types[0])[0]
      if (!option) return
      const subOption = option.children.filter(item => item.value === this.link_types[1])[0]
      if (!subOption) return
      let path = [option, subOption]
      let pathText = `${option.label} | ${subOption.label}`
      if (subOption.value === 'mini-page') {
        pathText = `微页面 | ${this.miniPageItem['page_name'] || ''}`
      }
      if (subOption.value === 'shop-home' && this.shopItem) {
        pathText = `店铺首页 | ${this.shopItem['shop_name']}`
      }
      if (subOption.value === 'custom') {
        pathText = `外链 | ${this.link.value}`
      }
      if (subOption.value === 'mini-program') {
        pathText = this.link.value === '/promotion-module/points-mall/points-mall'
          ? '积分商城' : `小程序路径 | ${this.link.value}`
      }
      if (subOption.value === 'coupon') {
        pathText = `指定优惠券 | ${this.link.name || this.link.value}`
      }
      if (subOption.value === 'goods-group') {
        pathText = `商品分组 | ${(this.goodsGroupItem && this.goodsGroupItem.group_name) || this.link.name || ''}`
      }
      return { path, pathText }
    }
  },
  methods: {
    /**
     * 选择器值发生改变
     * @param item
     */
    async handleCascaderChange(item) {
      const link_type = item[item.length -1]
      let link = { type: link_type, value: '' }
      switch (link_type) {
        case 'points-mall':
          // 复用已发布小程序支持的内部路径，不要求买家端增加新的链接类型。
          link.type = 'mini-program'
          link.value = '/promotion-module/points-mall/points-mall'
          break
        case 'coupon':
          this.show_coupon_picker = true
          return
        case 'custom':
          link.value = await this.inputCustomLink(); break
        case 'mini-program':
          link.value = await this.inputMiniProgramLink(); break
        case 'mini-page':
          this.show_page_picker = true
          link.value = undefined
          break
        case 'shop-home':
          link.value = await this.getShopLink(); break
        case 'user-center':
          link.value = `member`; break
        case 'part-goods':
          this.show_goods_picker = true
          link.value = undefined
          break
        case 'goods-group':
          this.show_goods_group_picker = true
          link.value = undefined
          break
        default:
          link.value = `${link_type}`
      }
      if (link.value === undefined) return this.clearLink()
      this.link = link
      this.$emit('update', this.link)
    },
    /**
     * 清空值
     */
    clearLink() {
      this.show_coupon_picker = false
      this.$nextTick(() => {
        this.link = ''
        this.link_types = ''
      })
      this.$emit('update', '')
    },
    /**
     * 输入自定义链接
     * @returns {Promise<string>}
     */
    async inputCustomLink() {
      try {
        const res = await this.$prompt('请输入自定义链接', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: 'https://',
          inputPattern: Rules.url,
          inputErrorMessage: '链接格式不正确！'
        })
        return res.value
      } catch (e) {
        this.clearLink()
      }
    },
    /**
     * 输入小程序路径
     * @returns {Promise<string>}
     */
    async inputMiniProgramLink() {
      try {
        const res = await this.$prompt('填写小程序内部页面路径；积分商品入口为 /promotion-module/points-mall/points-mall。不能填写 #小程序:// 分享短链。', '小程序路径', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '/promotion-module/points-mall/points-mall',
          inputValidator: value => {
            const path = typeof value === 'string' ? value.trim() : ''
            return path.length <= 2048 && /^\/?(?:[A-Za-z0-9_-]+\/)+[A-Za-z0-9_-]+(?:\?[^\s#]*)?$/.test(path)
              ? true : '请填写小程序内部页面路径，不能填写 #小程序:// 分享短链或网页地址'
          }
        })
        return '/' + res.value.trim().replace(/^\//, '')
      } catch (e) {
        this.clearLink()
      }
    },
    /**
     * 默认值发生改变
     * @param newVal
     */
    async defaultValueChange(newVal) {
      this.link = newVal
      if (!newVal) this.link_types = ''
      let option = ''
      let subOption = ''
      for (let i = 0; i < this.options.length; i++) {
        option = this.options[i]
        if (option.value === newVal.type) break
        if (option.children && option.children.length) {
          subOption = option.children.filter(item => item.value === newVal.type)[0]
          if (subOption) break
          option = ''
          subOption = ''
        }
      }
      option && (this.link_types = [option.value])
      subOption && (this.link_types = [option.value, subOption.value])
      if (newVal && newVal.type === 'shop-home' && !this.shopItem) {
        this.shopItem = await API_Shop.getShopDetail(newVal.value)
      }
      if (newVal && newVal.type === 'mini-page' && !this.miniPageItem) {
        this.miniPageItem = await API_Pages.getPageDetail(newVal.value, false)
      }
      if (newVal && newVal.type === 'goods-group') {
        if (newVal.name) {
          this.goodsGroupItem = { group_id: newVal.value, group_name: newVal.name }
        } else if (!this.goodsGroupItem || String(this.goodsGroupItem.group_id) !== String(newVal.value)) {
          try {
            this.goodsGroupItem = await getVisibleGoodsGroup(newVal.value)
          } catch (e) {
            this.goodsGroupItem = { group_id: newVal.value, group_name: `ID：${newVal.value}` }
          }
        }
      }
    },
    /**
     * 获取店铺链接
     * @returns {Promise<string>}
     */
    async getShopLink() {
      if (this.$$ShopInfo) {
        return this.$$ShopInfo['shop_id']
      } else {
        this.show_shop_picker = true
        return undefined
      }
    },
    /**
     * 店铺选择器确认
     * @param items
     */
    handleShopPickerConfirm(items) {
      if (!items.length) return
      this.shopItem = items[0]
      this.link = {
        type: 'shop-home',
        value: items[0]['shop_id']
      }
      this.$emit('update', this.link)
    },
    /** 编辑已经绑定的指定优惠券，取消选择时保留原链接。 */
    editCouponLink() {
      if (!this.disabled && this.link && this.link.type === 'coupon') this.show_coupon_picker = true
    },
    /** 保存指定优惠券的模板编号与展示名称，编号始终保留为字符串。 */
    handleCouponPickerConfirm(coupon) {
      if (this.disabled || couponLinkUnavailableReason(coupon)) return
      const id = normalizeCouponLinkId(coupon && coupon.coupon_id)
      if (!id) return
      this.link_types = ['营销工具', 'coupon']
      this.link = { type: 'coupon', value: id, name: coupon.title || id }
      this.$emit('update', this.link)
    },
    /**
     * 商品选择器确认
     * @param items
     */
    handleGoodsPickerConfirm(items) {
      if (!items.length) return
      this.link = {
        type: 'part-goods',
        value: items[0]['goods_id']
      }
      this.$emit('update', this.link)
    },
    /**
     * 加载当前装修端可见的商品分组
     */
    async loadGoodsGroups() {
      this.goods_group_loading = true
      try {
        this.goods_group_options = await getVisibleGoodsGroups() || []
        const currentId = this.link && this.link.type === 'goods-group' ? this.link.value : ''
        this.$nextTick(() => {
          this.filterGoodsGroups()
          if (currentId && this.$refs.goodsGroupTree) this.$refs.goodsGroupTree.setCurrentKey(currentId)
        })
      } finally {
        this.goods_group_loading = false
      }
    },
    /** 只过滤节点显示，保留分组数据与当前选择。 */
    filterGoodsGroups() {
      if (this.$refs.goodsGroupTree) this.$refs.goodsGroupTree.filter(this.goods_group_keyword)
    },
    /** 名称模糊搜索忽略首尾空格和大小写，命中一级分组时同时显示其子分组。 */
    filterGoodsGroupNode(value, data, node) {
      const keyword = String(value || '').trim().toLowerCase()
      if (!keyword) return true
      if (String(data.group_name || '').toLowerCase().includes(keyword)) return true
      let parent = node && node.parent
      while (parent) {
        if (String((parent.data && parent.data.group_name) || '').toLowerCase().includes(keyword)) return true
        parent = parent.parent
      }
      return false
    },
    handleGoodsGroupSelect(item) {
      this.pending_goods_group = item
    },
    handleGoodsGroupConfirm() {
      const item = this.pending_goods_group
      if (!item) return
      this.goodsGroupItem = item
      this.link = {
        type: 'goods-group',
        value: item.group_id,
        name: item.group_name
      }
      this.show_goods_group_picker = false
      this.$emit('update', this.link)
    },
    resetGoodsGroupPicker() {
      this.goods_group_keyword = ''
      this.pending_goods_group = null
    },
    /**
     * 页面选择器确认
     * @param items
     */
    handlePagePickerConfirm(items) {
      if (!items.length) return
      this.miniPageItem = items[0]
      this.link = {
        type: 'mini-page',
        value: items[0].id
      }
      this.$emit('update', this.link)
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-group-picker-search { margin-bottom: 12px; }
.link-selector {
  position: relative;
  display: flex;
  width: 100%;
  .link-selector__link {
    display: inline-block;
    width: 100%;
  }
  /deep/ {
    .el-tag {
      display: flex;
      align-items: center;
      position: relative;
      color: #155bd4;
      border-color: #155bd4;
      border-radius: 2px;
      width: 100%;
      height: 28px;
      box-sizing: border-box;
      margin-right: 5px;
      overflow: hidden;
      .el-tag__close {
        position: absolute;
        top: auto;
        right: 5px;
        color: #155bd4;
        &:hover {
          color: #ffffff;
          background-color: #155bd4;
        }
      }
      .link-selector__tag-content {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
        max-width: 208px;
      }
    }
    .el-cascader {
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
.goods-group-picker {
  min-height: 180px;
  max-height: 420px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  .el-tree {
    padding: 6px 0;
  }
  .goods-group-picker__node {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    padding-right: 18px;
  }
  .goods-group-picker__count {
    color: #909399;
    font-size: 12px;
  }
}
</style>
